export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14964.d1fd1b42.jpg";